// extracted by mini-css-extract-plugin
export default {"meal":"MealItem_meal__RQD3j","description":"MealItem_description__WUdS1","price":"MealItem_price__VT0gJ"};